import React from "react";
import { makeStyles } from "@fluentui/react-components";
import { ArrowRight16Filled } from "@fluentui/react-icons";

/* global JSX */

interface DetailsCompareFieldProps {
  left: string | JSX.Element;
  right: string | JSX.Element;
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    gap: "8px",
  },
  detailsSide: {
    flex: "1 1 49%",
  },
  middleArrow: {
    flex: "1 1 auto",
    height: "16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

const RouteConnector: React.FC<DetailsCompareFieldProps> = ({
  left,
  right,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.detailsSide}>{left}</div>
      <div className={styles.middleArrow}>
        <ArrowRight16Filled />
      </div>
      <div className={styles.detailsSide}>{right}</div>
    </div>
  );
};

export default RouteConnector;
